import React, {useState} from 'react';
import {
  Stepper,
  Step,
  Toolbar,
  StepLabel,
  StepContent,
  Typography,
  Button,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Tooltip,
  IconButton,
} from '@material-ui/core';
import InitialAuditInformation from './InitialAuditInformation';
import './EnrollmentApplicationProcessing.sass';
import {showModal, ModalState} from 'Core/ducks/modal';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PublishRoundedIcon from '@material-ui/icons/PublishRounded';
import {useDispatch} from 'react-redux';
import RecordValidationDetails from './RecordValidationDetails';

enum Steps {
  FileUpload = 'File Upload',
  ImportValidation = 'Import Validation',
  InternalReview = 'Internal Review',
  AuditValidation = 'Audit Validation',
  RecordValidation = 'Record Validation',
  Complete = 'Complete',
}
const appProcessingSteps: string[] = [
  Steps.FileUpload,
  Steps.ImportValidation,
  Steps.InternalReview,
  Steps.AuditValidation,
  Steps.RecordValidation,
  Steps.Complete,
];

const getStepContent = (step: number) => {
  switch (appProcessingSteps[step]) {
    case Steps.FileUpload:
      return '';
    case Steps.ImportValidation:
      return 'Import Validation details';
    case Steps.InternalReview:
      return 'Internal review Details';
    case Steps.AuditValidation:
      return <InitialAuditInformation />;
    case Steps.RecordValidation:
      return <RecordValidationDetails />;
    case Steps.Complete:
      return 'Processing Completed';
    default:
      return 'Unknown step';
  }
};

const EnrollmentApplicationProcessing = () => {
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState<number>(0);

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  return (
    <div className="enrollment-app-processing">
      <Toolbar className="enrollment-app-processing__header">
        <Typography className="upload-enrollment-files-table__title" variant="h6">
          Enrollment Application Processing
        </Typography>
        <Tooltip title="Upload File">
          <IconButton
            className="btn-upload"
            onClick={() => dispatch(showModal(ModalState.EnrollmentApplicationUpload()))}
            aria-label="Upload File"
          >
            <PublishRoundedIcon />
          </IconButton>
        </Tooltip>
      </Toolbar>
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <div className="enrollment-app-processing__fileDetails">
            <div className="enrollment-app-processing__fileDetails__icon-container">
              <i className="icon-container__file-icon"></i>
            </div>
          </div>
        </ExpansionPanelSummary>

        <ExpansionPanelDetails></ExpansionPanelDetails>
      </ExpansionPanel>

      <div className="enrollment-app-processing__vertical-stepper">
        <Stepper activeStep={activeStep} orientation="vertical">
          {appProcessingSteps.map((label, index) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
              <StepContent>
                <Typography>{getStepContent(index)}</Typography>
                <div className="enrollment-app-processing__controls">
                  <Button disabled={activeStep === 0} onClick={handleBack}>
                    Back
                  </Button>
                  <Button variant="contained" color="primary" onClick={handleNext}>
                    {activeStep === appProcessingSteps.length - 1 ? 'Finish' : 'Next'}
                  </Button>
                </div>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </div>
    </div>
  );
};

export default EnrollmentApplicationProcessing;
